/* eslint-disable react/prop-types */
/** @jsxRuntime classic */
/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import { typography } from "../../../styles/typography";
import { useColor as colors } from "../../../theme";
const Points = ({
  data,
  getX,
  getY,
  maxY,
  minX,
  minY,
  pointsColor,
  pointsIsHoverOnZone,
  onEnter,
  onRemote,
  viewBoxWidth,
  pointsRadius,
  pointsStrokeHover,
  pointsStrokeColor,
  pointsVisible,
  strokeWidth,
  onClick,
  unitWidth,
  pointHoverAlignment
}) => {
  const PointCSS = css`
        fill: ${colors[pointsColor] || pointsColor};
        stroke: ${pointsStrokeColor};
        stroke-width: ${strokeWidth};
        &:hover {
            cursor: pointer;
            fill: #fff;
            stroke: ${colors[pointsColor] || pointsColor};
            stroke-width: ${pointsStrokeHover};
        }
    `;
  const textChartCSS = css`
        text-anchor: middle;
        ${typography.paragraph3};
    `;

  // create drawing function tooltips in different positions
  const topTooltipPath = (width, height, offset, radius) => {
    const left = -width / 2;
    const right = width / 2;
    const top = -offset - height;
    const bottom = -offset;
    return `M 0,0
            L ${-offset},${bottom} 
            H ${left + radius}
            Q ${left},${bottom} ${left},${bottom - radius}  
            V ${top + radius}   
            Q ${left},${top} ${left + radius},${top}
            H ${right - radius}
            Q ${right},${top} ${right},${top + radius}
            V ${bottom - radius}
            Q ${right},${bottom} ${right - radius},${bottom}
            H ${offset} 
            L 0,0 z`;
  };
  const bottomTooltipPath = (width, height, offset, radius) => {
    const left = -width / 2;
    const right = width / 2;
    const bottom = offset + height;
    const top = offset;
    return `M 0,0 
            L ${-offset},${top} 
            H ${left + radius}
            Q ${left},${top} ${left},${top + radius}  
            V ${bottom - radius}   
            Q ${left},${bottom} ${left + radius},${bottom}
            H ${right - radius}
            Q ${right},${bottom} ${right},${bottom - radius}
            V ${top + radius}
            Q ${right},${top} ${right - radius},${top}
            H ${offset} 
            L 0,0 z`;
  };
  const leftTooltipPath = (width, height, offset, radius) => {
    const left = -offset - width;
    const right = -offset;
    const top = -height / 2;
    const bottom = height / 2;
    return `M 0,0 
            L ${right},${-offset} 
            V ${top + radius}
            Q ${right},${top} ${right - radius},${top}  
            H ${left + radius}   
            Q ${left},${top} ${left},${top + radius}
            V ${bottom - radius}
            Q ${left},${bottom} ${left + radius},${bottom}
            H ${right - radius}
            Q ${right},${bottom} ${right},${bottom - radius}
            V ${offset} 
            L 0,0 z`;
  };
  const rightTooltipPath = (width, height, offset, radius) => {
    const left = offset;
    const right = offset + width;
    const top = -height / 2;
    const bottom = height / 2;
    return `M 0,0 
            L ${left},${-offset} 
            V ${top + radius}
            Q ${left},${top} ${left + radius},${top}  
            H ${right - radius}   
            Q ${right},${top} ${right},${top + radius}
            V ${bottom - radius}
            Q ${right},${bottom} ${right - radius},${bottom}
            H ${left + radius}
            Q ${left},${bottom} ${left},${bottom - radius}
            V ${offset} 
            L 0,0 z`;
  };

  // Create event management function
  const MouseEnterTarget = (e, i) => {
    if (onEnter) onEnter(e, i);
    document.getElementById('tooltipLine' + i).style.display = 'block';
  };
  const MouseLeaveTarget = (e, i) => {
    if (onRemote) onRemote(e, i);
    document.getElementById('tooltipLine' + i).style.display = 'none';
  };
  const handleChange = event => {
    if (onClick) onClick(event);
  };

  // Create function to display tooltip by position
  const getPlacement = (point, i) => {
    // convert number -> string
    const h = `${point.quantity}`;
    var Width = 0;
    var x = 0;
    var y = 0;
    var x1 = 0;
    var y1 = 0;
    if (h.length == 2 || h.length == 1 || h.length == 3) {
      Width += 35;
      x += 23;
      y += -8;
      x1 += -23;
      y1 += -8;
    }
    if (h.length == 4 || h.length == 5) {
      Width += 40;
      x += 26;
      y += -8;
      x1 += -26;
      y1 += -8;
    }
    if (h.length == 6 || h.length == 7) {
      Width += 50;
    }
    if (h.length == 8 || h.length == 9) {
      Width += 70;
    }
    if (h.length == 10 || h.length == 11) {
      Width += 90;
    }
    const toolTipRight = jsx("g", {
      id: `tooltipLine` + i,
      className: 'DGN-Tooltip-Bar',
      style: {
        display: 'none'
      },
      transform: `translate(${getX(point.x + unitWidth / 1.5) + 4}, ${getY(point.quantity)})`
    }, jsx("path", {
      d: rightTooltipPath(Width, 20, 6, 4),
      fill: colors[pointsColor] || pointsColor,
      stroke: colors[pointsColor] || pointsColor,
      style: {
        filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.15))'
      }
    }), jsx("text", {
      x: x,
      y: y,
      dy: "1em",
      css: textChartCSS,
      fill: "#fff"
    }, point.quantity));
    const toolTipLeft = jsx("g", {
      id: `tooltipLine` + i,
      className: 'DGN-Tooltip-Bar',
      style: {
        display: 'none'
      },
      transform: `translate(${getX(point.x + unitWidth / 1.5) - 4}, ${getY(point.quantity)})`
    }, jsx("path", {
      d: leftTooltipPath(Width, 20, 6, 4),
      fill: colors[pointsColor] || pointsColor,
      stroke: colors[pointsColor] || pointsColor,
      style: {
        filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.15))'
      }
    }), jsx("text", {
      x: x1,
      y: y1,
      dy: "1em",
      css: textChartCSS,
      fill: "#fff"
    }, point.quantity));
    const toolTipTop = jsx("g", {
      id: `tooltipLine` + i,
      className: 'DGN-Tooltip-Bar',
      style: {
        display: 'none'
      },
      transform: `translate(${getX(point.x + unitWidth / 1.5)}, ${getY(point.quantity) - 4})`
    }, jsx("path", {
      d: topTooltipPath(Width, 20, 6, 4),
      fill: colors[pointsColor] || pointsColor,
      stroke: colors[pointsColor] || pointsColor,
      style: {
        filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.15))'
      }
    }), jsx("text", {
      y: "-23",
      dy: "1em",
      css: textChartCSS,
      fill: "#fff"
    }, point.quantity));
    const toolTipBottom = jsx("g", {
      id: `tooltipLine` + i,
      className: 'DGN-Tooltip-Bar',
      style: {
        display: 'none'
      },
      transform: `translate(${getX(point.x + unitWidth / 1.5)}, ${getY(point.quantity) + 4})`
    }, jsx("path", {
      d: bottomTooltipPath(Width, 20, 6, 4),
      fill: colors[pointsColor] || pointsColor,
      stroke: colors[pointsColor] || pointsColor,
      style: {
        filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.15))'
      }
    }), jsx("text", {
      y: "10",
      dy: "1em",
      css: textChartCSS,
      fill: "#fff"
    }, point.quantity));
    if (pointHoverAlignment) {
      switch (pointHoverAlignment) {
        case 'right':
          return toolTipRight;
        case 'left':
          return toolTipLeft;
        case 'top':
          return toolTipTop;
        case 'bottom':
        default:
          return toolTipBottom;
      }
    } else {
      if (getX(point.x + unitWidth / 1.5) < 20) {
        return toolTipRight;
      }
      if (getX(point.x + unitWidth / 1.5) > viewBoxWidth) {
        return toolTipLeft;
      }
      if (getY(point.quantity) > 10) {
        return toolTipTop;
      }
      return toolTipBottom;
    }
  };
  return pointsVisible ? jsx("g", {
    className: 'DGN-Point-LineChart'
  }, data.map((point, i) => {
    return jsx("g", {
      key: i,
      className: 'DGN-Point' + i
    }, jsx("circle", {
      key: i,
      css: PointCSS,
      r: point.active ? pointsRadius * 1.2 : pointsRadius,
      cx: getX(point.x + unitWidth / 1.5),
      cy: getY(point.quantity),
      onMouseEnter: e => MouseEnterTarget(e, i),
      onMouseLeave: e => MouseLeaveTarget(e, i),
      onClick: handleChange
    }), getPlacement(point, i));
  }), pointsIsHoverOnZone && data.map((point, i) => {
    return jsx("g", {
      key: i,
      className: 'DGN-Point' + i
    }, jsx("rect", {
      key: i,
      x: getX(point.x > minX ? (data[i].x + data[i - 1].x) / 2 : minX),
      y: getY(maxY),
      fill: 'transparent',
      width: getX(1),
      height: getY(minY),
      onMouseEnter: e => MouseEnterTarget(e, i),
      onMouseLeave: e => MouseLeaveTarget(e, i),
      onClick: handleChange
    }), getPlacement(point, i));
  })) : null;
};
Points.propTypes = {
  /** the getX position x on Ox*/
  getX: PropTypes.func,
  /** the getY position y on Oy */
  getY: PropTypes.func,
  /** the maxX is maximum of Ox quantity returned by data*/
  maxX: PropTypes.number,
  /** the maxY is maximum of Oy quantity returned by data*/
  maxY: PropTypes.number,
  /** the minX is minimum of OX quantity returned by data*/
  minX: PropTypes.number,
  /** the minY is minimum of Oy quantity returned by data*/
  minY: PropTypes.number,
  /** change the inner color of the point button  */
  pointsColor: PropTypes.string,
  /** show data information when hovering in the area containing the column */
  pointsIsHoverOnZone: PropTypes.bool,
  /** change the radius of the point is created */
  pointsRadius: PropTypes.number,
  /** change the border color of the point button  */
  pointsStrokeColor: PropTypes.string,
  /** show or hiden point */
  pointsVisible: PropTypes.bool,
  /** the unitWidth */
  unitWidth: PropTypes.number,
  /** the direction to display tootip */
  pointHoverAlignment: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};
Points.defaultProps = {
  getX: x => x,
  getY: quantity => quantity,
  pointsColor: '#0095FF',
  pointsIsHoverOnZone: false,
  pointsVisible: false,
  unitWidth: 1,
  pointsRadius: 3,
  pointsStrokeHover: 2
};
export default Points;